import { Col, Row, Table, Card } from "react-bootstrap";
import { useFetch } from "hooks/api";
import Loading from "components/core/blocks/Loading";
import { formatNumber } from "utils/formatNumber";
import moment from "moment";
import { keepPreviousData } from "@tanstack/react-query";

const IncomingInventory = ({ product }) => {
  const { data: daysOnHandData, isLoading: daysOnHandLoading } = useFetch(
    ["days_on_hand", product?.id],
    `/merchandise/days_on_hand`,
    {
      product_ids: product?.id,
      market_place: product?.market_place,
    },
    {
      select: (d) => d.data,
      placeholderData: keepPreviousData,
      enabled: !!product?.id,
    },
  );

  // console.log(daysOnHandData);

  if (daysOnHandLoading) {
    return <Loading height={"300px"} fullPage={false} />;
  }

  return (
    <Row className="p-3">
      <Col xs={12}>
        <Row>
          <Col xs={3}>
            <Card>
              <Card.Body>
                <div className="py-2 px-4 text-center">
                  <div className="fs-4">Daily Avg (30 days)</div>
                  <div className="fs-2 fw-bold">
                    {formatNumber(daysOnHandData.daily_units.thirty, { decimalPlaces: 0 })}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card>
              <Card.Body>
                <div className="py-2 px-4 text-center">
                  <div className="fs-4">Daily Avg (60 days)</div>
                  <div className="fs-2 fw-bold">
                    {formatNumber(daysOnHandData.daily_units.sixty, { decimalPlaces: 0 })}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card>
              <Card.Body>
                <div className="py-2 px-4 text-center">
                  <div className="fs-4">Daily Avg (90 days)</div>
                  <div className="fs-2 fw-bold">
                    {formatNumber(daysOnHandData.daily_units.ninety, { decimalPlaces: 0 })}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card>
              <Card.Body>
                <div className="py-2 px-4 text-center">
                  <div className="fs-4">Inventory on Hand</div>
                  <div className="fs-2 fw-bold">
                    {formatNumber(daysOnHandData.total_units_sum.total_units_sum, { decimalPlaces: 0 })}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Table>
              <thead>
                <tr>
                  <th className="text-start">Date</th>
                  <th className="text-end">Quantity (30)</th>
                  <th className="text-end">Quantity (60)</th>
                  <th className="text-end">Quantity (90)</th>
                  <th className="text-end">Incoming Inventory</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(daysOnHandData.days_on_hand).map((date, i) => (
                  <tr key={i}>
                    <td>{moment(date).format("MMMM Do YYYY")}</td>
                    <td className="text-end">
                      {formatNumber(daysOnHandData.days_on_hand[date].thirty.units, { decimalPlaces: 0 })}
                      &nbsp;(
                      {formatNumber(daysOnHandData.days_on_hand[date].thirty.days_on_hand, { decimalPlaces: 0 })})
                      <div>
                        <small>{daysOnHandData.days_on_hand[date].thirty.status}</small>
                      </div>
                    </td>
                    <td className="text-end">
                      {formatNumber(daysOnHandData.days_on_hand[date].sixty.units, { decimalPlaces: 0 })}&nbsp;(
                      {formatNumber(daysOnHandData.days_on_hand[date].sixty.days_on_hand, { decimalPlaces: 0 })})
                      <div>
                        <small>{daysOnHandData.days_on_hand[date].sixty.status}</small>
                      </div>
                    </td>
                    <td className="text-end">
                      {formatNumber(daysOnHandData.days_on_hand[date].ninety.units, { decimalPlaces: 0 })}&nbsp;(
                      {formatNumber(daysOnHandData.days_on_hand[date].ninety.days_on_hand, { decimalPlaces: 0 })})
                      <div>
                        <small>{daysOnHandData.days_on_hand[date].ninety.status}</small>
                      </div>
                    </td>
                    <td className="text-end">
                      {formatNumber(daysOnHandData.incoming_inventory[date], { decimalPlaces: 0 })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>

        <Row className="fs-5 text-center pt-5">
          <Col xs={12} className="text-start fs-5">
            <span className="fs-1 fw-bold">Incoming Inventory</span>
            <div
              style={{
                padding: "2rem",
                border: "1px solid rgb(238, 238, 238)",
                borderRadius: "6px",
                backgroundColor: "rgb(248, 248, 248)",
                marginTop: "10px",
              }}
            >
              <div>This table shows the incoming inventory based on the data provided by the seller.</div>
            </div>

            <Table>
              <thead>
                <tr>
                  <th className="text-start">Incoming Date</th>
                  <th className="text-start">Quantity</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(daysOnHandData.incoming_inventory).map((date, i) => (
                  <tr key={i}>
                    <td>{moment(date).format("MMMM Do YYYY")}</td>
                    <td>{formatNumber(daysOnHandData.incoming_inventory[date])}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default IncomingInventory;
